export const cattleQuestions = {
  type: 'What do you want to do?',
  product_type: 'Livestock type',
  quantity: 'Quantity',
  quantity_min: 'Quantity (min)',
  quantity_max: 'Quantity (max)',
  availability: 'Delivery Period',
  availability_from: 'From',
  availability_to: 'To',
  stock_category: 'Stock category(s)',
  stock_gender: 'Stock gender(s)',
  pregnancy_status: 'Pregnancy status(s)',
  stock_ages: 'Stock age(s)',
  weaning_date: 'Weaning date(s)',
  dentition: 'Dentition(s)',
  breed: 'Breed',
  purebred_breed: 'Purebred breed & bloodline (if known)',
  mixed_breed_name: 'Mixed breed name/type',
  mixed_breed_composition: 'Min composition (%)',
  weighed: 'Have they been weighed?',
  last_weighed: 'Date weighed',
  expected_weight_at_delivery: 'Expected weight at delivery',
  min: 'Min (kg)',
  avg: 'Avg. (kg)',
  max: 'Max (kg)',
  weight_expected_min: 'Expected weight AT DELIVERY (min)?',
  weight_expected_max: 'Expected weight AT DELIVERY (max)?',
  feed_type: 'What feed(s) are they on? ',
  num_days_grain: 'Number of days on grain/pellet',
  treatments: 'Have they had any animal health treatments?',
  treatment_name: 'Treatment details',
  treatment_date: 'Treatment date',
  withholding: 'Are they in a withholding period?',
  withholding_finish_date: 'When does their withholding period finish?',
  hgp_free: 'Are they HGP free?',
  lifetime_traceable: 'Are they lifetime traceable?',
  vendor_bred: 'Are they vendor bred',
  blue_tongue_free: 'Are they from a Blue Tongue Free Zone?',
  tick_free_zone: 'Are they from a Tick Free Zone?',
  lpa_accredited: 'Are they LPA accredited?',
  antibiotic_free: 'Are they antibiotic free?',
  organic: 'Are they organic?',
  fit_to_load: 'Will they be fit to load?',
  horns: "Do any of the cattle you're listing have horns?",
  horn_type: 'Horn description',
  horn_length: 'Maximum horn length (cm)',
  target_price: 'Do you have a target price?',
  liveweight_price: '$/kg liveweight',
  hscw_price: '$/kg HSCW',
  head_target_price: '$/head',
  agent: 'Are you an agent or getting an agent to help you?',
  agent_name: 'Agent name',
  agent_branch: 'Branch',
  agent_agency: 'Agency',
  comments: 'Do you have any other comments?',
  postcode: 'Where are the livestock located?',
  pic: 'Property Identification Code (PIC)',
  listing_name: 'Give your listing a name',
  media: 'Media',
  tags: 'Tag Colour(s)',
  lice: 'Do they have lice?',
  stock_type: 'Stock type(s)?',
  lamb_drop: 'Lamb / hogget drop(s)',
  footrot: 'Do they have footrot?',
  wool_fibre_length: 'Last shorn',
  fat_condition: 'Expected fat/condition(s) score AT DELIVERY',
  delivery_arrangement:
    'Can you deliver or arrange for the stock to be delivered?',
  delivery_at_short_notice:
    'Can the stock be ready at short notice (< 3 days)?',
  blemishes:
    'Do the livestock have any blemishes (eg arthritis, pink eye, warts)?',
  blemishes_detail:
    'Please describe the blemishes and include images if you have photos',
  is_brokerage_fee_payable:
    'You acknowledge that there is a brokerage fee if Agora Livestock find you a counterparty (Free plans: 5% for sheep & goats, 2.5% for cattle. Base plan or higher: 1% for sheep & goats, 0.5% for cattle)',
  mulesed: 'Have these sheep been mulesed?',
  negotiable_price: 'This price is',
  payable_brokerage_fee: 'What $/head fee would you pay?',
  price_type: 'Price type',
  indicative_price: 'Indicative prices are required for POA listings.',
  indicative_price_desc:
    'This is to ensure listings have realistic market expectations - but they will not be visible to users viewing your listing.',
  enquiries: 'Are you happy to take enquiries from (select those that apply)?',
  anonymous: 'Would you like to make your listing anonymous?',
  publish_action: 'Publish on the Agora Marketplace?',
  head_networks:
    "Select networks you've been added to to share your listing in",
  my_networks: "Select networks you've created to share your listing in",
};
